(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
//<script>
  $(document).ready(function() {
    function topBarTimer() {
      var myTimezone = "America/New_York";
      var datetimeFormat = "YYYY-MM-DD HH:mm";
      var timeString_current = moment().tz(myTimezone).format(datetimeFormat);
      if(document.getElementById("current_date")){
        document.getElementById("current_date").innerHTML = timeString_current;
      }      
      var timeString_compare  = $('#compare_date').attr('data-settings');
      if(document.getElementById("compare_date")){
        document.getElementById("compare_date").innerHTML = timeString_compare;
      }   
      
      //console.log('timeString_compare = ' + timeString_compare);

      // Compare current NYC time with expiration date in settings
      if(moment().isBefore(moment.tz(timeString_compare, 'YYYY-MM-DD HH:mm', 'America/New_York'), 'second')) {
        //console.log('it is before ' + timeString_compare + ' in new york');
        $('.timer-bar').removeClass("hide").addClass("show");
      } else {
        //console.log('it is after ' + timeString_compare + ' in new york');
      };
    }

    topBarTimer();
  });
//</script>

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
//<script>
  $(document).ready(function() {
    function topBarTimer() {
      var myTimezone = "America/New_York";
      var datetimeFormat = "YYYY-MM-DD HH:mm";
      var timeString_current = moment().tz(myTimezone).format(datetimeFormat);
      if(document.getElementById("current_date")){
        document.getElementById("current_date").innerHTML = timeString_current;
      }
     // document.getElementById("current_date").innerHTML = timeString_current;
      var timeString_compare  = $('#compare_date').attr('data-settings');
      if(document.getElementById("compare_date")){
        document.getElementById("compare_date").innerHTML = timeString_compare;
      }
      //document.getElementById("compare_date").innerHTML = timeString_compare;
      //console.log('timeString_compare = ' + timeString_compare);

      // Compare current NYC time with expiration date in settings
      if(moment().isBefore(moment.tz(timeString_compare, 'YYYY-MM-DD HH:mm', 'America/New_York'), 'second')) {
        //console.log('it is before ' + timeString_compare + ' in new york');
        $('.timer-bar').removeClass("hide").addClass("show");
      } else {
        //console.log('it is after ' + timeString_compare + ' in new york');
      };
    }

    topBarTimer();
  });
//</script>

  } catch(e) { console.error(e); }
})();
})();
